import { OnRaceBetsSchema } from './OnRaceBets.styles';

export const onRaceBetStyles: OnRaceBetsSchema = {
  wrapper: {
    my: '2',
    border: 'node',
    borderRadius: 'md',
    flexDirection: 'column',
    bg: 'beta.100',
    boxShadow:
      '0px 3px 4px 0px rgba(0, 0, 0, 0.15),0px 0px 0px 2px rgba(255, 255, 255, 1) inset, 0px 0px 0px 3px rgba(200, 178, 119, 1) inset',
  },
  headerWrapper: {
    px: '2.5',
    flexDirection: 'row',
    alignItems: 'center',
    mx: '0.5',
    py: '1.5',
    lineHeight: 'normal',
  },
  headerText: {
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'heading',
    color: 'beta.800',
    pt: '0.5',
  },
  headerCountText: {
    ml: '1',
    fontSize: '2xs',
    fontWeight: 'semibold',
    color: 'beta.500',
    p: '1',
    bg: 'beta.800',
    borderRadius: 'base',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    lineHeight: 'normal',
  },
  headerExpandButton: {
    variant: 'unstyled',
    ml: 'auto',
    mr: '1',
    color: 'beta.800',
    boxSize: '7',
    _hover: {
      color: 'beta.800',
    },
  },
  toggleIcon: {
    boxSize: '4',
  },
  betsContainer: {
    flexDirection: 'column',
    borderTop: '1px solid rgba(0, 0, 0, 0.25)',
    mx: '1',
  },
  betCategoryWrapper: {
    alignItems: 'center',
    mt: '2',
  },
  betCategory: {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'alpha.700',
  },
  betCategoryCount: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'alpha.700',
    ml: '1',
  },
  divider: {
    borderWidth: 'px',
    opacity: '1',
    borderColor: 'blackAlpha.400',
    mt: '1.5',
  },
  betRow: {
    py: '2',
    px: '2',
    gap: '2',
    bg: 'beta.700',
    borderRadius: 'base',
    mb: '1',
    _last: {
      mb: '0',
    },
  },
  betRowDivider: {
    bg: 'beta.700',
    borderRadius: 'base',
    mb: '1',
    p: '2',
    _last: {
      mb: '0',
    },
  },
  groupDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.400',
  },
  categoryIcon: {
    color: 'beta.500',
    boxSize: '6',
  },
  groupContainer: {
    flexDir: 'column',
    py: 2,
    px: '2',
    border: 'none',
    boxShadow: 'none',
  },
  groupTitleText: {
    fontFamily: 'accent',
    color: 'beta.800',
    fontSize: 'sm',
    fontWeight: 'normal',
  },
  runnerText: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  runnerBarrierText: {
    color: 'beta.500',
    fontSize: 'xs',
  },
  stakeText: {
    color: 'beta.500',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  potentialWinningsText: {
    color: 'beta.500',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  subtitleText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
  },
  exoticsPositionText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
    w: 9,
  },
  viewMoreButton: {
    alignItems: 'center',
    justifyContent: 'center',
    mb: -2,
    borderTopRadius: 0,
    height: 8,
  },
  viewMoreButtonText: {
    fontWeight: 'normal',
    fontSize: 'sm',
    textTransform: 'uppercase',
  },
  srmBlendedLegContainer: {
    flexDir: 'row',
    flex: '1',
  },
  srmBlendedRunnerText: {
    width: 32,
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
    textTransform: 'capitalize',
  },
  srmMarketText: {
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
  },
  srmBlendedWrapper: {
    flexDir: 'column',
    flex: 1,
  },
  flexiText: {
    fontWeight: 'normal',
    color: 'white',
    fontSize: 'xs',
  },
  flexiStakeText: {
    width: '16',
    color: 'white',
  },
  flexiStakeValueText: {
    color: 'alpha.400',
    fontWeight: 'bold',
  },
};
